"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByProperty = void 0;
function sortByProperty(array, sortingProperty, sortingOrder) {
    if (array.length < 2) {
        return array;
    }
    array.sort((a, b) => {
        let aValue = a[sortingProperty];
        let bValue = b[sortingProperty];
        const aParsed = parseFloat(aValue);
        const bParsed = parseFloat(bValue);
        if (!isNaN(aParsed) && !isNaN(bParsed)) {
            aValue = aParsed;
            bValue = bParsed;
        }
        if (typeof aValue === "number" && typeof bValue === "number") {
            if (sortingOrder === "ASC") {
                return aValue - bValue;
            }
            else if (sortingOrder === "DESC") {
                return bValue - aValue;
            }
        }
        else if (typeof aValue === "string" && typeof bValue === "string") {
            if (sortingOrder === "ASC") {
                return aValue.localeCompare(bValue);
            }
            else if (sortingOrder === "DESC") {
                return bValue.localeCompare(aValue);
            }
        }
        return 0;
    });
    return array;
}
exports.sortByProperty = sortByProperty;
